
export const safeParseDate = (dateValue: any): string | undefined => {
  if (!dateValue) return undefined;


  if (typeof dateValue === 'string' && dateValue.trim() !== '') {
    const date = new Date(dateValue);
    if (!isNaN(date.getTime())) {
      return dateValue;
    }
  }


  if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
    return dateValue.toISOString();
  }

  return undefined;
};


export const formatDate = (
  dateValue: any,
  options?: Intl.DateTimeFormatOptions
): string => {
  if (!dateValue) return 'N/A';

  const date = new Date(dateValue);
  if (isNaN(date.getTime())) {
    return 'N/A';
  }

  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options,
  };

  return date.toLocaleDateString(undefined, defaultOptions);
};


export const formatDateTime = (
  dateValue: any,
  options?: Intl.DateTimeFormatOptions
): string => {
  if (!dateValue) return 'N/A';

  const date = new Date(dateValue);
  if (isNaN(date.getTime())) {
    return 'N/A';
  }

  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...options,
  };

  return date.toLocaleString(undefined, defaultOptions);
};


export const isValidDate = (dateValue: any): boolean => {
  if (!dateValue) return false;

  const date = new Date(dateValue);
  return !isNaN(date.getTime());
};





